// StatCard — single big-number widget for the creator analytics dashboard.
import React from 'react';
import { B } from '../constants';

function formatNumber(n) {
  if (typeof n !== 'number' || Number.isNaN(n)) return '—';
  if (Math.abs(n) >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (Math.abs(n) >= 1_000)     return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}

export default function StatCard({ label, value, formatter = formatNumber, hint, accent = B.forest }) {
  return (
    <div style={{
      background: '#fff', borderRadius: 12, padding: 18,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)', minWidth: 160,
      borderTop: `4px solid ${accent}`,
    }}>
      <div style={{
        fontFamily: "'Montserrat',sans-serif", fontSize: 11, color: B.muted,
        textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6,
      }}>
        {label}
      </div>
      <div style={{
        fontFamily: "'Playfair Display',serif", fontSize: 32, fontWeight: 700,
        color: B.night, lineHeight: 1.1,
      }}>
        {formatter(value)}
      </div>
      {hint && (
        <div style={{ marginTop: 6, fontSize: 12, color: B.muted, fontFamily: "'Montserrat',sans-serif" }}>
          {hint}
        </div>
      )}
    </div>
  );
}

export { formatNumber };
